var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.items_list),function(elem){return _c(elem.component,{key:elem.component+'_'+elem.name,tag:"component",staticClass:"qmkey-chip",attrs:{"item":elem,"disable":_vm.disable},on:{"update":_vm.chip_clicked}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }